import React from 'react';
import PropTypes from 'prop-types';
import {ThemeProvider as StyledComponentsThemeProvider, createGlobalStyle} from 'styled-components';
import {Normalize} from 'styled-normalize';
import {colorDarkest, copyColor, copyFontFamily, copyLineHeight} from './selectors';
import {brandFonts} from './fonts';
import {ThemeSchema, PropsWithTheme, ModeSchema, formTypes} from './types';

export interface ThemeProviderProps extends PropsWithTheme {
  mode?: ModeSchema;
}

const Reset = createGlobalStyle`
  html {
    color: ${({theme}: {theme: ThemeSchema}) => (theme.id === 'nib' ? colorDarkest : copyColor)};
    font-family: ${copyFontFamily};
    font-weight: ${({theme}: {theme: ThemeSchema}) => theme.copy.fontWeight};
    line-height: ${copyLineHeight};
    /* Not setting font-size because we want 16px */
    font-display: swap;
  }
`;

const Theme: React.FC<ThemeProviderProps> = ({children, theme, mode}) => {
  const themeWithFormMode = mode ? {...theme, mode} : theme;
  const BrandFonts = brandFonts[theme.id];
  return (
    <StyledComponentsThemeProvider theme={themeWithFormMode}>
      <React.Fragment>
        <Normalize />
        <Reset />
        {BrandFonts && <BrandFonts />}
        {children}
      </React.Fragment>
    </StyledComponentsThemeProvider>
  );
};

Theme.displayName = 'Theme';

Theme.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.any.isRequired,
  mode: PropTypes.shape({
    form: PropTypes.oneOf(formTypes).isRequired
  })
};

export default Theme;

export * from './selectors';
export * from './brands';
export * from './types';
export * from './common';
